import React from "react";
import Modal from "react-bootstrap/Modal";
import UploaderArquivos from "./index";

const ModalUploader = ({
    show,
    onClose,
    pergunta,
    bucketName,
    tipoPermissao,
    IDDiretorio,
    onUploadFinalizado,
    permitirDocs = true,
}) => {
    return !!bucketName && IDDiretorio ?
        (
            <Modal
                show={show}
                onHide={onClose}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: 18 }}>Anexar Arquivos - {pergunta?.pergunta.slice(0, 50)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UploaderArquivos
                        tipoPermissao={tipoPermissao ?? 99}
                        bucketName={bucketName}
                        IDDiretorio={IDDiretorio}
                        setExibirUploader={onClose}
                        onUploadFinalizado={onUploadFinalizado}
                        permitirDocs={permitirDocs}
                        //setAtualizarArquivos aki aki aki Felipe
                    />
                </Modal.Body>
            </Modal>
        )
        :
        (
            <Modal
                show={show}
                onHide={onClose}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: 18 }}>Anexar Arquivos - {pergunta?.pergunta.slice(0, 50)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <span>Não foi possível carregar o conteúdo</span>
                    </div>
                </Modal.Body>
            </Modal>
        );
};

export default ModalUploader;
